var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 28.3334C24 21.7084 29.375 16.3334 36 16.3334C42.625 16.3334 48 21.7084 48 28.3334C48 34.9584 42.625 40.3334 36 40.3334C29.3717 40.3334 24 34.9584 24 28.3334ZM35.3867 32.3134L41.6083 26.0917C42.1333 25.6417 42.1275 24.7284 41.6075 24.2075C41.0875 23.6867 40.2433 23.6867 39.7225 24.2075L34.4442 29.4859L32.275 27.3175C31.755 26.7967 30.9108 26.7975 30.39 27.3175C29.8692 27.8375 29.8692 28.6817 30.39 29.2025L33.5017 32.3134C33.7618 32.5739 34.1032 32.704 34.4442 32.704C34.7851 32.704 35.1262 32.5738 35.3867 32.3134Z",
    fill: "#6F3289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 11V0.333374H7.26083C6.10417 0.333374 5.09417 1.06254 4.72917 2.15671L0.03125 10.9C0.046875 10.9209 0.0572917 10.9355 0.0677083 10.95C0.078125 10.9646 0.0885417 10.9792 0.104167 11H17.3333ZM32.6083 2.15671C32.2417 1.06254 31.2333 0.333374 30.075 0.333374H20V11H37.2333C37.249 10.9792 37.2594 10.9636 37.2698 10.948C37.2802 10.9323 37.2906 10.9167 37.3062 10.8959L32.6083 2.15671ZM4 37.6667C1.79083 37.6667 0 35.875 0 33.6667V13.6667H36C27.9 13.6667 21.3333 20.2334 21.3333 28.3334C21.3333 31.875 22.5917 35.1334 24.6833 37.6667H4Z",
    fill: "#6F3289"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryPurple);
export default __webpack_public_path__ + "static/media/delivery-purple.ff47919fbedc069247476aeae2595580.svg";
export { ForwardRef as ReactComponent };